import { useSelector } from 'react-redux'
import { RouteConfig } from 'view/routes'

const NULL_SELECTOR = () => null
const TRUTHY_SELECTOR = () => true

export function useRouteConfigSelectors(routeConfig: RouteConfig) {
  const numberOfItems = useSelector(routeConfig.itemCountSelector ?? NULL_SELECTOR)
  const showActivityHighlight = useSelector(routeConfig.activityHighlightSelector ?? NULL_SELECTOR)
  const showAlertHighlight = useSelector(routeConfig.alertHighlightSelector ?? NULL_SELECTOR)
  const showWarnHighlight = useSelector(routeConfig.warnHighlightSelector ?? NULL_SELECTOR)
  const visible = useSelector(routeConfig.visibleSelector ?? TRUTHY_SELECTOR)

  return {
    numberOfItems,
    showWarnHighlight,
    showActivityHighlight,
    showAlertHighlight,
    visible
  }
}
